(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["on-cart"] && !Shopify.designMode) return;
  try {
    /* Omgång 35: en prisruta vars delar alla saknar innehåll döljs. Gäller främst
     Delbetalning (Shopifys payment_terms), som är tom när beloppet eller marknaden
     inte kvalificerar; hamnar den ensam mellan två block blev det en tom ruta.
     Mäts bara när lådan syns (stängd låda = allt 0 px). setTimeout, ingen
     MutationObserver: lådan ritas om vid varje korgändring. */
  (function () {
    function check() {
      document.querySelectorAll('.on-cart-seg.cart-totals').forEach(function (box) {
        if (!box.closest('dialog[open]') && !box.offsetParent) return;
        var kids = Array.prototype.filter.call(box.children, function (c) { return c.tagName !== 'STYLE' && c.tagName !== 'SCRIPT'; });
        var tom = kids.length > 0 && kids.every(function (c) { return c.getBoundingClientRect().height < 2; });
        box.classList.toggle('on-seg-empty', tom);
      });
    }
    function later() { [0, 250, 900, 2500].forEach(function (ms) { setTimeout(check, ms); }); }
    document.addEventListener('cart:update', later);
    /* Horizons dialog skickar dialog:open när lådan öppnas, oavsett hur. */
    document.addEventListener('dialog:open', later, true);
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('cart-icon, .header-actions__cart-icon, [href$="/cart"], button[name="add"], cart-drawer-component')) later();
    }, true);
    later();
  })();
  } catch(e) { console.error(e); }
})();

})();
